import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, ContentChild, input, TemplateRef } from '@angular/core';

@Component({
  selector: 'f-basic-card',
  templateUrl: './basic-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet]
})
export class BasicCardComponent {
  @ContentChild('fHeaderTitle', { read: TemplateRef }) headerTitle!: TemplateRef<unknown>;
  @ContentChild('fContent', { read: TemplateRef }) contentTemplate!: TemplateRef<unknown>;
}
